import { c as _c } from "react/compiler-runtime";
import { Drawer } from '@petsmart-ui/sparky';
import React from 'react';
import { LogoWrapper } from '@libs/contentful';
import Menu from '@/components/Menu/Menu';
import type { NavigationDrawerProps } from '@/types';
import './navigationDrawer.scss';
const componentClassName = 'main-navigation-drawer';
export function NavigationDrawer(t0) {
  const $ = _c(7);
  const {
    handleClose,
    isActive
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Drawer.Header><LogoWrapper className="c-global-header__logo" data-testid="logo-wrapper" /></Drawer.Header>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== handleClose) {
    t2 = <Drawer.Body className={`${componentClassName}__body`}><Menu handleClose={handleClose} /></Drawer.Body>;
    $[1] = handleClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleClose || $[4] !== isActive || $[5] !== t2) {
    t3 = <Drawer data-testid={componentClassName} isActive={isActive} onClose={handleClose} ariaLabelledBy="site-navigation-drawer" className={componentClassName}>{t1}{t2}</Drawer>;
    $[3] = handleClose;
    $[4] = isActive;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}